import React from "react";

const UserSearchOutlineIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
    <path d="M9 9.5625C6.6225 9.5625 4.6875 7.6275 4.6875 5.25C4.6875 2.8725 6.6225 0.9375 9 0.9375C11.3775 0.9375 13.3125 2.8725 13.3125 5.25C13.3125 7.6275 11.3775 9.5625 9 9.5625ZM9 2.0625C7.245 2.0625 5.8125 3.495 5.8125 5.25C5.8125 7.005 7.245 8.4375 9 8.4375C10.755 8.4375 12.1875 7.005 12.1875 5.25C12.1875 3.495 10.755 2.0625 9 2.0625Z" fill="#163B84"/>
    <path d="M2.55762 17.0625C2.25012 17.0625 1.99512 16.8075 1.99512 16.5C1.99512 13.2975 5.13764 10.6875 9.00014 10.6875C9.30764 10.6875 9.56264 10.9425 9.56264 11.25C9.56264 11.5575 9.30764 11.8125 9.00014 11.8125C5.76014 11.8125 3.12012 13.9125 3.12012 16.5C3.12012 16.8075 2.86512 17.0625 2.55762 17.0625Z" fill="#163B84"/>
    <path d="M13.65 16.6125C12.015 16.6125 10.6875 15.285 10.6875 13.65C10.6875 12.015 12.015 10.6875 13.65 10.6875C15.285 10.6875 16.6125 12.015 16.6125 13.65C16.6125 15.285 15.285 16.6125 13.65 16.6125ZM13.65 11.8125C12.6375 11.8125 11.8125 12.6375 11.8125 13.65C11.8125 14.6625 12.6375 15.4875 13.65 15.4875C14.6625 15.4875 15.4875 14.6625 15.4875 13.65C15.4875 12.6375 14.6625 11.8125 13.65 11.8125Z" fill="#163B84"/>
    <path d="M16.5 17.0625C16.3575 17.0625 16.215 17.01 16.1025 16.8975L15.3525 16.1475C15.135 15.93 15.135 15.57 15.3525 15.3525C15.57 15.135 15.93 15.135 16.1475 15.3525L16.8975 16.1025C17.115 16.32 17.115 16.68 16.8975 16.8975C16.785 17.01 16.6425 17.0625 16.5 17.0625Z" fill="#163B84"/>
    </g>
  </svg>
);

export default UserSearchOutlineIcon;
